import { SecureLinkCreationInitiatedEventProps } from 'models/MixpanelEvents';
import { CreateDataRoomShareableLinkForm } from 'models/ShareableLink';
import { useCallback, useContext } from 'react';
import mixpanelService from 'services/mixpanelService';
import { LINK_ACCESS, EXPIRE_AFTER } from './data';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { useTranslation } from 'react-i18next';
import { getIsLinkExpiresOther } from 'router/subrouters/DataRoom/utils';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

const useCreateSecureLinkMixpanelProps = () => {
  const {
    isOwner,
    dataRoom: { _id: dataRoomId, name: dataRoomName },
  } = useContext(DataRoomContext);

  const getMixpanelProps = useGetMixpanelProps();

  const { t } = useTranslation();

  return useCallback(
    (link: CreateDataRoomShareableLinkForm) =>
      mixpanelService.secureLinkCreationInitiated(
        getMixpanelProps({
          linkName: link.name,
          linkAccess: t(LINK_ACCESS[link.linkAccess]),
          linkExpiration: getIsLinkExpiresOther(link.linkExpires)
            ? link.linkExpiresDate.toString()
            : t(EXPIRE_AFTER[link.linkExpires]),
          linkProtection: link.includeNdaProtection
            ? t('nda')
            : link.includeTermsAndConditionProtection
            ? t('tAndC')
            : t('nothing'),
          isOwner,
          dataRoomId,
          dataRoomName,
        }) as SecureLinkCreationInitiatedEventProps,
      ),
    [isOwner, dataRoomId, dataRoomName, getMixpanelProps, t],
  );
};

export default useCreateSecureLinkMixpanelProps;
